import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import React, { useContext } from 'react';
import { useHistory } from 'react-router';
import { ControlLabel } from 'react-bootstrap';

import Context from '../../Context';

const Checkbox = styled.input`
  margin-left: 12px !important;
  position: relative;
  top: 2px;
`;
Checkbox.defaultProps = {
  type: 'checkbox',
};

function BulkSelect({ bulkSelectAll, setBulkSelectAll }) {
  const history = useHistory();
  const { greetIds, bulkSelect } = useContext(Context);

  function handleCheckboxChange(evt) {
    if (evt.target.checked) {
      bulkSelect.checkMany(greetIds);
      history.replace('/home/bulk-select');
    } else {
      bulkSelect.uncheckAll();
      history.replace('/home');
    }
    setBulkSelectAll(evt.target.checked);
  }

  return (
    <React.Fragment>
      <ControlLabel>
        <Checkbox onChange={handleCheckboxChange} checked={bulkSelectAll} />
        {` ${bulkSelectAll ? 'Deselect' : 'Select'} all`}
      </ControlLabel>
    </React.Fragment>
  );
}

BulkSelect.propTypes = {
  bulkSelectAll: PropTypes.bool.isRequired,
  setBulkSelectAll: PropTypes.func.isRequired,
};

export default BulkSelect;
